module.exports = __webpack_public_path__ + "img/cats_spot.44b846b1.jpg";